import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { MenuService } from '../_services/menu.service'

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

@Component({
  selector: 'menu-usuario',
  templateUrl: 'menu.template.html'
})
export class MenuComponent implements OnInit {

  opciones : any;
  showNavBar: boolean = true;
  menuextendido: boolean = true;

  constructor(private router:Router,
              private http: Http,
              private menuService: MenuService,
              private globalEventsManager: GlobalEventsManager){

    //console.log("entro menu");
    this.globalEventsManager.showNavBarEmitter.subscribe((mode)=>{
            // mode will be null the first time it is created, so you need to igonore it when null
            if (mode !== null) {
              this.showNavBar = mode;
              if (this.showNavBar){
                this.getMenu();
              }
            }
        });

    this.globalEventsManager.menuExtendidoEmitter.subscribe((mode)=>{

            if (mode !== null) {
              this.menuextendido = mode;

            }
        });

  }

  toggleMenu(){
    if (this.menuextendido){
      this.globalEventsManager.menuExtendido(false);
    }else{
      this.globalEventsManager.menuExtendido(true);
    }
  }

  ngOnInit(){
    this.getMenu();
  }

  getMenu(){

    this.menuService.getMenu().subscribe(
      data => {
        //console.log(data.json().menu);
        if (data){
          this.pintarMenu(data.json());
        }
      }
    );

  }

  pintarMenu(response:any){

    let menu = response.menu;
    this.opciones = menu;

  }

  navegar(destino: string){
    this.router.navigate([destino]);
  }

  link(accion){
    if (accion){
      return accion;
    }else{
      return this.router.url;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/menu/menu.component.ts